import i18nFactory from '@yandex-int/i18n';
import { Spin } from 'lego-on-react';
import { isUndefined } from 'lodash';
import * as React from 'react';
import { RefObject } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { DEFAULT_FETCH_LIMIT, GALLERY_FETCH_OFFSET_STEP } from '../common/typings';

import './GalleryPane.css';
import * as keyset from './GalleryPane.i18n';

const i18n = i18nFactory(keyset);

export interface GalleryPaneProps {
    collectionLength: number;

    total: number;
    isAllItemsLoading?: boolean;
    isMoreItemsLoading?: boolean;
    paneFilters?: React.ReactNode;
    // нужно чтобы перерисовывались item-ы при проигрывании аудио-превью
    previewItemIndex?: number;

    applyItem: (collectionIndex?: number) => void;
    loadMoreItems: (limit: number) => void;
    itemRenderer: (index: number) => React.ReactNode;
}

const BLOCK = 'gallery-pane';

export class GalleryPane extends React.PureComponent<GalleryPaneProps> {
    private paneBodyRef: RefObject<HTMLDivElement> = React.createRef();

    render() {
        const { paneFilters } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                {paneFilters && <div className={Bem.cls(BLOCK, 'filters')}>{paneFilters}</div>}
                <div
                    className={Bem.cls(BLOCK, 'pane-body', {
                        'has-filter': !isUndefined(paneFilters)
                    })}
                    onScroll={this.onGalleryPaneScroll}
                    ref={this.paneBodyRef}
                >
                    {this.getPaneBodyContent()}
                </div>
            </div>
        );
    }

    private getPaneBodyContent() {
        const { isMoreItemsLoading, isAllItemsLoading } = this.props;

        if (isAllItemsLoading) {
            return <Spin cls={Bem.cls(BLOCK, 'spin-all')} size={'s'} progress={true} />;
        }

        return (
            <>
                {this.renderGalleryItems()}
                <div className={Bem.cls(BLOCK, 'spin-more-wrapper')}>
                    <Spin cls={Bem.cls(BLOCK, 'spin-more')} size={'s'} progress={isMoreItemsLoading} />
                </div>
            </>
        );
    }

    private onGalleryPaneScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const paneBodyElem = this.paneBodyRef.current;
        if (paneBodyElem) {
            const isAtBottom = paneBodyElem.scrollHeight - paneBodyElem.scrollTop === paneBodyElem.clientHeight;

            if (isAtBottom) {
                const { total, collectionLength, isMoreItemsLoading } = this.props;

                // уже нечего загружать или уже загружаем
                if (total === collectionLength || isMoreItemsLoading) {
                    return;
                }

                let newLimit;

                const notLoadedItemsCount = total - collectionLength;

                if (notLoadedItemsCount > GALLERY_FETCH_OFFSET_STEP) {
                    newLimit = DEFAULT_FETCH_LIMIT;
                } else {
                    newLimit = notLoadedItemsCount;
                }

                this.props.loadMoreItems(newLimit);
            }
        }
    };

    private renderGalleryItems() {
        const { collectionLength, total, itemRenderer } = this.props;

        if (total === 0) {
            return <div className={Bem.cls(BLOCK, 'not-found-message')}>{i18n('empty-gallery-message')}</div>;
        }

        const items = [];

        for (let index = 0; index < collectionLength; index++) {
            items.push(itemRenderer(index));
        }

        return items;
    }
}
